"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootReducers = void 0;
const tslib_1 = require("tslib");
const items_1 = tslib_1.__importDefault(require("./items"));
const bookings_1 = tslib_1.__importDefault(require("./bookings"));
const user_1 = tslib_1.__importDefault(require("./user"));
const users_1 = tslib_1.__importDefault(require("./users"));
const schedule_1 = tslib_1.__importDefault(require("./schedule"));
const customers_1 = tslib_1.__importDefault(require("./customers"));
const store_1 = tslib_1.__importDefault(require("./store"));
const search_1 = tslib_1.__importDefault(require("./search"));
const marketplace_1 = tslib_1.__importDefault(require("./marketplace"));
const inquiries_1 = tslib_1.__importDefault(require("./inquiries"));
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
exports.rootReducers = {
    items: items_1.default || (() => ({})),
    bookings: bookings_1.default || (() => ({})),
    user: user_1.default || (() => ({})),
    users: users_1.default || (() => ({})),
    schedule: schedule_1.default || (() => ({})),
    customers: customers_1.default || (() => ({})),
    store: store_1.default || (() => ({})),
    search: search_1.default || (() => ({})),
    marketplace: marketplace_1.default || (() => ({})),
    inquiries: inquiries_1.default || (() => ({})),
};
const store = toolkitRaw.configureStore({
    reducer: exports.rootReducers,
});
exports.default = store;
//# sourceMappingURL=redux.js.map